import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import VisibilityOutlined from "@mui/icons-material/VisibilityOutlined";
import { useTranslationApp } from "../../lib/i18next";
import {
  APPROVAL_REVIEWER_LABEL,
  APPROVAL_REVIEWING_AS_PREFIX,
} from "../../i18n/keysTranslations";
import { INPUT_COLOR_BORDER } from "../../utils/colors";
import { hasMultipleApprovalReviewers } from "./approvalReviewersUtils";

const PRIMARY_APPROVAL_REVIEWER_NUMBER = 1;

const ApprovalCurrentReviewerBanner = ({
  currentReviewer = null,
  reviewers = [],
  showReviewerIcon = true,
}) => {
  const { t } = useTranslationApp();

  if (!currentReviewer || !hasMultipleApprovalReviewers(reviewers)) {
    return null;
  }

  const email = currentReviewer?.email?.trim?.() || "";
  const reviewerLabel = email
    ? email
    : t(APPROVAL_REVIEWER_LABEL, { number: PRIMARY_APPROVAL_REVIEWER_NUMBER });

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: showReviewerIcon ? 1 : 1.5,
        py: 1,
        borderRadius: 2,
        border: `1px solid ${INPUT_COLOR_BORDER}`,
        bgcolor: "action.hover",
      }}
    >
      {showReviewerIcon && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            width: 24,
            height: 24,
            flexShrink: 0,
            borderRadius: "50%",
            bgcolor: "action.selected",
            color: "text.primary",
          }}
        >
          <VisibilityOutlined sx={{ fontSize: 14 }} />
        </Box>
      )}
      <Typography variant="body2" sx={{ color: "text.secondary" }}>
        {t(APPROVAL_REVIEWING_AS_PREFIX)}{" "}
        <Box component="span" sx={{ fontWeight: 600, color: "text.primary" }}>
          {reviewerLabel}
        </Box>
      </Typography>
    </Box>
  );
};

export default ApprovalCurrentReviewerBanner;
